<div class="space-y-6">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'WRITEOFF.TITLE' | translate }}
      </h1>
      <p class="text-gray-600 dark:text-gray-400 mt-1">
        {{ 'WRITEOFF.SUBTITLE' | translate }}
      </p>
    </div>
    <p-button
      [label]="'WRITEOFF.ADD_BTN' | translate"
      icon="pi pi-minus-circle"
      severity="danger"
      (onClick)="openDialog()"
      styleClass="w-full sm:w-auto"
    />
  </div>

  <!-- Filters -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
    <div class="grid grid-cols-2 gap-3 lg:flex lg:flex-wrap lg:items-center">
      <!-- Product filter -->
      <div class="col-span-2 flex gap-2 lg:col-auto">
        <!--
          `virtualScroll` majburiy: mahsulotlar ro'yxati minglab bo'lishi mumkin va
          usiz PrimeNG hammasini DOM'ga chizib, dropdown ochilishini muzlatib qo'yadi.
        -->
        <p-select
          [options]="allProducts()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'WRITEOFF.FILTER.PRODUCT' | translate"
          [filter]="true"
          filterBy="name,barcode"
          [showClear]="true"
          [loading]="productsLoading()"
          [virtualScroll]="true"
          [virtualScrollItemSize]="38"
          [(ngModel)]="filterProductId"
          appendTo="body"
          class="flex-1 lg:w-48 lg:flex-none"
        />
        <app-barcode-scanner (barcodeDetected)="onFilterBarcodeDetected($event)" />
      </div>

      <!-- Store filter — bitta do'konda "hammasi" bilan bir xil, shuning uchun yo'q. -->
      @if (storePick.visible()) {
        <p-multiselect
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'WRITEOFF.FILTER.STORE' | translate"
          [showClear]="true"
          [(ngModel)]="filterStoreIds"
          appendTo="body"
          display="chip"
          class="w-full lg:w-44"
        />
      }

      <!-- Type filter -->
      <p-select
        [options]="stockTypes()"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'WRITEOFF.FILTER.TYPE' | translate"
        [showClear]="true"
        [(ngModel)]="filterType"
        appendTo="body"
        class="w-full lg:w-40"
      />

      <!-- Date range -->
      <div class="w-full lg:w-40">
        <p-datepicker
          [(ngModel)]="filterFrom"
          [placeholder]="'WRITEOFF.FILTER.DATE_FROM' | translate"
          dateFormat="dd.mm.yy"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
        />
      </div>
      <div class="w-full lg:w-40">
        <p-datepicker
          [(ngModel)]="filterTo"
          [placeholder]="'WRITEOFF.FILTER.DATE_TO' | translate"
          dateFormat="dd.mm.yy"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
        />
      </div>

      <!-- Action button -->
      <div class="col-span-2 flex justify-end lg:col-auto lg:ml-auto">
        <p-button
          [label]="'WRITEOFF.FILTER.SEARCH' | translate"
          icon="pi pi-search"
          severity="success"
          size="small"
          (onClick)="applyFilters()"
        />
      </div>
    </div>
  </div>

  <!-- History Table -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden"
  >
    <div class="overflow-x-auto">
      <p-table
        [value]="historyItems()"
        [lazy]="true"
        (onLazyLoad)="loadHistory($event)"
        [totalRecords]="totalCount()"
        [paginator]="true"
        [rows]="pageSize"
        [rowsPerPageOptions]="[20, 50, 100]"
        [loading]="loading()"
        [showCurrentPageReport]="false"
        [showFirstLastIcon]="false"
        [tableStyle]="{ 'min-width': '72rem' }"
        styleClass="p-datatable-gridlines"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">{{ 'WRITEOFF.TABLE.NUMBER' | translate }}</th>
            <th>{{ 'WRITEOFF.TABLE.PRODUCT' | translate }}</th>
            <th>{{ 'WRITEOFF.TABLE.STORE' | translate }}</th>
            <th>{{ 'WRITEOFF.TABLE.TYPE' | translate }}</th>
            <th class="text-right">{{ 'WRITEOFF.TABLE.QUANTITY' | translate }}</th>
            <th class="text-right">{{ 'WRITEOFF.TABLE.PURCHASE_PRICE' | translate }}</th>
            <th class="text-right">{{ 'WRITEOFF.TABLE.SELL_PRICE' | translate }}</th>
            <th>{{ 'WRITEOFF.TABLE.EMPLOYEE' | translate }}</th>
            <th>{{ 'WRITEOFF.TABLE.COMMENT' | translate }}</th>
            <th>{{ 'WRITEOFF.TABLE.DATE' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr>
            <td class="text-gray-400 text-sm">{{ rowIndex + 1 }}</td>

            <td>
              <div class="flex flex-col">
                <span class="font-medium text-gray-900 dark:text-gray-100 text-sm">
                  {{ item.productName }}
                </span>
                @if (item.variantLabel) {
                  <span
                    class="inline-flex items-center mt-0.5 w-fit text-xs font-medium text-indigo-600 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-900/30 px-1.5 py-0.5 rounded"
                  >
                    {{ item.variantLabel }}
                  </span>
                }
                <code class="text-xs text-gray-400 mt-0.5">{{ item.productBarcode }}</code>
              </div>
            </td>

            <td class="text-sm text-gray-600 dark:text-gray-400">{{ item.storeName }}</td>

            <td>
              <p-tag [value]="typeLabel(item.type)" [severity]="typeSeverity(item.type)" />
            </td>

            <td
              class="text-right font-semibold"
              [class.text-red-600]="item.quantityChange < 0"
              [class.text-emerald-600]="item.quantityChange > 0"
            >
              {{ item.quantityChange > 0 ? '+' : '' }}{{ item.quantityChange }}
            </td>

            <td class="text-right text-sm text-gray-600 dark:text-gray-400">
              {{ item.purchasePrice | money: item.currency }}
            </td>

            <td class="text-right text-sm text-gray-600 dark:text-gray-400">
              {{ item.sellPrice | money: item.currency }}
            </td>

            <td class="text-sm text-gray-600 dark:text-gray-400">{{ item.userFullName }}</td>

            <td
              class="text-sm text-gray-500 dark:text-gray-400 max-w-[12rem] truncate"
              [pTooltip]="item.description"
              tooltipPosition="top"
            >
              {{ item.description || '—' }}
            </td>

            <td class="text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap">
              {{ formatDate(item.createdAt) }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10" class="text-center py-16 text-gray-400">
              <div class="flex flex-col items-center gap-3">
                <i class="pi pi-inbox text-5xl text-gray-200"></i>
                <span>{{ 'WRITEOFF.TABLE.EMPTY' | translate }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Write-Off Dialog -->
<p-dialog
  [header]="'WRITEOFF.DIALOG.TITLE' | translate"
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: 'min(34rem, 95vw)' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="flex flex-col gap-4 pt-2">
    <!-- Product + barcode -->
    <div class="flex flex-col gap-1">
      <label for="wo-product" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'WRITEOFF.DIALOG.PRODUCT_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <div class="flex gap-2">
        <p-select
          inputId="wo-product"
          [options]="allProducts()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'WRITEOFF.DIALOG.PRODUCT_PLACEHOLDER' | translate"
          [filter]="true"
          filterBy="name,barcode"
          [loading]="productsLoading()"
          [virtualScroll]="true"
          [virtualScrollItemSize]="38"
          [ngModel]="form.productId"
          (ngModelChange)="onWriteOffProductChange($event)"
          appendTo="body"
          class="flex-1"
        />
        <app-barcode-scanner (barcodeDetected)="onBarcodeDetected($event)" />
      </div>
    </div>

    <!-- Store — bitta bo'lsa `openDialog()` da o'zi qo'yiladi. -->
    @if (storePick.visible()) {
      <div class="flex flex-col gap-1">
        <label for="wo-store" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'WRITEOFF.DIALOG.STORE_LABEL' | translate }} <span class="text-red-500">*</span>
        </label>
        <p-select
          inputId="wo-store"
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'WRITEOFF.DIALOG.STORE_PLACEHOLDER' | translate"
          [ngModel]="form.storeId"
          (ngModelChange)="onWriteOffStoreChange($event)"
          appendTo="body"
          class="w-full"
        />
      </div>
    }

    <!-- Variant (faqat variantli mahsulotda) -->
    @if (hasRealVariants()) {
      <div class="flex flex-col gap-1">
        <label for="wo-variant" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'WRITEOFF.DIALOG.VARIANT_LABEL' | translate }} <span class="text-red-500">*</span>
        </label>
        <p-select
          inputId="wo-variant"
          [options]="variantOptions()"
          optionLabel="label"
          optionValue="id"
          [placeholder]="'WRITEOFF.DIALOG.VARIANT_PLACEHOLDER' | translate"
          [(ngModel)]="form.productVariantId"
          [loading]="variantsLoading()"
          appendTo="body"
          class="w-full"
        >
          <ng-template let-opt pTemplate="item">
            <div class="flex items-center justify-between gap-3 w-full">
              <span>{{ opt.label }}</span>
              <span class="text-xs text-gray-400">
                {{ opt.stock }} {{ 'PRODUCTS.DETAIL.PCS' | translate }}
                @if (opt.defectiveStock > 0) {
                  <span class="text-amber-600 dark:text-amber-400"
                    >· {{ 'WRITEOFF.DIALOG.DEFECTIVE_SHORT' | translate }}
                    {{ opt.defectiveStock }}</span
                  >
                }
              </span>
            </div>
          </ng-template>
        </p-select>
      </div>
    }

    <!-- Brak ombordan chiqarish -->
    <div
      class="flex items-center justify-between gap-3 rounded-lg border border-gray-200 dark:border-gray-700 px-3 py-2.5"
    >
      <div class="flex items-center gap-2">
        <p-checkbox inputId="wo-defective" [(ngModel)]="form.fromDefective" [binary]="true" />
        <label for="wo-defective" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'WRITEOFF.DIALOG.FROM_DEFECTIVE' | translate }}
        </label>
      </div>
      <span class="text-xs text-gray-400">
        {{ 'WRITEOFF.DIALOG.DEFECTIVE_AVAILABLE' | translate }}:
        <span class="font-semibold text-amber-600 dark:text-amber-400">{{
          defectiveAvailable()
        }}</span>
      </span>
    </div>

    <!-- Quantity -->
    <div class="flex flex-col gap-1">
      <label for="wo-qty" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'WRITEOFF.DIALOG.QUANTITY_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <p-inputnumber
        inputId="wo-qty"
        placeholder="0"
        [min]="1"
        [(ngModel)]="form.quantity"
        class="w-full"
      />
    </div>

    <!-- Reason -->
    <div class="flex flex-col gap-1">
      <label for="wo-desc" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'WRITEOFF.DIALOG.REASON_LABEL' | translate }} <span class="text-red-500">*</span>
      </label>
      <textarea
        id="wo-desc"
        pTextarea
        [(ngModel)]="form.description"
        [placeholder]="'WRITEOFF.DIALOG.REASON_PLACEHOLDER' | translate"
        rows="3"
        class="w-full resize-none"
      ></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'WRITEOFF.DIALOG.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="dialogVisible = false"
      [disabled]="saving"
    />
    <p-button
      [label]="'WRITEOFF.DIALOG.SAVE' | translate"
      icon="pi pi-minus-circle"
      severity="danger"
      (onClick)="saveWriteOff()"
      [loading]="saving"
    />
  </ng-template>
</p-dialog>
